// Registry of grid behaviors.
// Add new behaviors here — they'll be available to any grid column
// via the `behavior` key in the column def.

import { currency } from "./currency"
import { number } from "./number"
import { vinLookup } from "./vin_lookup"
import { location } from "./location"
import { vehicleSpec } from "./vehicle_spec"
import { menu } from "./menu"
import { select } from "./select"
import { positiveNegative } from "./positive_negative"
import { html } from "./html"
import { fileList } from "./file_list"

const behaviors = {
  currency,
  number,
  vinLookup,
  location,
  vehicleSpecMake: vehicleSpec("make"),
  vehicleSpecEngine: vehicleSpec("engine_size"),
  vehicleSpecTransmission: vehicleSpec("transmission_type"),
  vehicleSpecType: vehicleSpec("vehicle_type"),
  menu,
  select,
  positiveNegative,
  html,
  fileList
}

export default behaviors
